<template>
    <v-app>
        <LoginModal />

        <router-view></router-view>
    </v-app>
</template>

<script>
// TEST CI
import LoginModal from "./components/shared/LoginModal";

export default {
    name: "App",
    components: {
        LoginModal,
    },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Fahkwang:wght@200;300;400;500;600;700&display=swap");
@import url("http://fonts.cdnfonts.com/css/signerica-fat?styles=42601");

.myFont {
    font-family: "Fahkwang", sans-serif;
}

.mySignature {
    font-family: "Signerica Fat", sans-serif;
}
</style>
